import { observer } from 'mobx-react';
import PreviewError from './PreviewError';
import PreviewSkeleton from './PreviewSkeleton';
import Ready from './Ready';
import { previewStore } from '../LearningCollectionPreviewStore';

function Previewer() {
  const { state } = previewStore;

  switch (state.kind) {
    case 'error':
      return <PreviewError />;
    case 'loading':
    case 'saving-from-publishing':
    case 'saving-from-creating':
    case 'saving-from-save-and-editing':
    case 'waiting':
    case 'discarding-changes':
      return <PreviewSkeleton />;
    case 'ready':
    case 'recommendations-incoming':
    case 'confirming-cancel':
    case 'confirming-cancel-from-create':
    case 'confirming-cancel-from-publish':
    case 'confirming-cancel-from-save-and-edit':
    case 'creating':
    case 'publishing':
    case 'save-and-editing':
    case 'publish-celebration':
    case 'save-celebration':
      return <Ready />;
  }
}

export default observer(Previewer);
